import { useContext } from 'react';
import { ThemeContext, type ThemeContextType } from './ThemeContext';

// Kept separate from ThemeContext.tsx so that file only exports components (react-refresh).
export function useTheme(): ThemeContextType {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
